import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';

export interface ReportTypingState {
  /** 已打字节点id列表 */
  typedNodeIdList: string[];
  /** 等待打字的节点id */
  waitNodeIdList: string[];
  /** 当前正在打字的节点id */
  currentNodeId: string | null;
}

const initialState: ReportTypingState = {
  typedNodeIdList: [],
  waitNodeIdList: [],
  currentNodeId: null,
};

const reportTypingSlice = createSlice({
  name: 'reportTyping',
  initialState,
  reducers: {
    setCurrentNodeId: (state, action: PayloadAction<string | null>) => {
      state.currentNodeId = action.payload;
    },
    /** 添加已打字节点id */
    addTypedNodeId: (state, action: PayloadAction<string>) => {
      // 从等待列表中移除
      state.waitNodeIdList = state.waitNodeIdList.filter(
        id => id !== action.payload,
      );
      state.typedNodeIdList.push(action.payload);
    },
    /** 添加等待打字节点id */
    addWaitNodeId: (state, action: PayloadAction<string>) => {
      // 避免重复添加
      if (
        state.waitNodeIdList.includes(action.payload) ||
        state.typedNodeIdList.includes(action.payload)
      ) {
        return;
      }
      state.waitNodeIdList.push(action.payload);
    },
    /** 重置报告打字状态 */
    resetReportTypingState: state => {
      Object.assign(state, cloneDeep(initialState));
    },
  },
});

export const {
  resetReportTypingState,
  setCurrentNodeId,
  addTypedNodeId,
  addWaitNodeId,
} = reportTypingSlice.actions;
export default reportTypingSlice.reducer;
